function getFirstComingSoonDrop() {
  const firstComingSoonButton = document.querySelector('.m-nehd-list__card .upcoming-product');
  if (!firstComingSoonButton) return { title: '', description: '' };

  const card = firstComingSoonButton.closest('.m-nehd-list__card');
  const heading = card?.querySelector('.m-nehd-list-card__heading');
  const title = card?.querySelector('.m-nehd-list-card__title');

  return {
    title: heading?.innerHTML || '',
    description: title?.innerHTML || '',
  };
}

function populateModalWithDropInfo(modal, dropInfo = null) {
  const customData = modal.querySelector('.klavio_custom_html_data');
  if (!customData) return;

  const info = dropInfo || getFirstComingSoonDrop();
  customData.innerHTML = `
    <div class="m-nehd-list-card__heading ne-body-eyebrow">${info.title}</div>
    <div class="m-nehd-list-card__title ne-display-sm">${info.description}</div>
  `;
}

function openHolidayModal(modal, trigger = null) {
  if (typeof modal.show === 'function') {
    modal.show(trigger);
  } else {
    modal.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  }
}

function closeHolidayModal(modal) {
  if (typeof modal.hide === 'function') {
    modal.hide();
  } else {
    modal.removeAttribute('open');
  }
  document.body.classList.remove('overflow-hidden');
}

function setupHolidayModalClose(modal, sectionElement) {
  ['close', 'hide'].forEach((eventName) => {
    modal.addEventListener(eventName, () => {
      if (sectionElement) {
        sectionElement.classList.remove('m-holiday-hero--open', 'section-holiday-drops--open');
      }
      document.body.classList.remove('overflow-hidden');
    });
  });

  const closeButton = modal.querySelector('[id^="ModalClose-"]');
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      closeHolidayModal(modal);
      if (sectionElement) {
        sectionElement.classList.remove('m-holiday-hero--open', 'section-holiday-drops--open');
      }
    });
  }

  const content = modal.querySelector('.product-popup-modal__content');
  if (content) {
    content.addEventListener('click', (event) => {
      if (event.target === content && closeButton) {
        closeButton.click();
      }
    });
  }
}

function setupKlaviyoFormHandlers(formId, popupId) {
  window.addEventListener('klaviyoForms', (event) => {
    if (!event?.detail) return;

    if (event.detail.type === 'viewedStep' && event.detail.formId === formId) {
      setTimeout(() => {
        const extraLink = document.querySelector('.go3176171171 a');
        if (!extraLink) return;

        extraLink.addEventListener('click', () => {
          const modal = document.querySelector(`#${popupId}`);
          const hostSection = document.querySelector('.section-holiday-drops');

          if (hostSection) {
            hostSection.classList.remove('section-holiday-drops--open');
          }

          if (modal) {
            closeHolidayModal(modal);
          }
        });
      }, 100);
    }

    if (event.detail.type === 'open' && event.detail.formId === formId) {
      setTimeout(() => {
        const info = document.querySelector('.go3176171171');
        if (!info) return;
        info.innerHTML = '<div>' + (window.klaviyoCardTitle || '') + '</div><div>' + (window.klaviyocardProductTitle || '') + '</div>';
      }, 100);
    }
  });
}
